export const checkSessionAction = (payload) => ({
  type: "REQ_SESSION_REQUESTED",
  payload,
});
